import { c as i } from "../../../../index.esm-BeDSGXP5.js";
import { css as t } from "styled-components";
import "../../../../colors-C72eWVhK.js";
import { FONT_SIZES as n } from "../../constants/constants.mjs";
const r = (o) => o.componentColors.totalizer, m = {
  fontSize: i({
    fontSize: [
      n.TEXT_MEDIUM_MOBILE,
      null,
      n.TEXT_LARGE_DESKTOP
    ]
  }),
  text: ({ theme: o, error: e }) => /* @__PURE__ */ t([
    "",
    ";color:",
    ";"
  ], o.components.totalizer.fontSize, e ? r(o).text.error : r(o).text.normal),
  amount: ({ theme: o }) => /* @__PURE__ */ t([
    "",
    ";font-weight:",
    ";color:inherit;"
  ], o.components.totalizer.fontSize, o.fontWeights.bold),
  bar: ({ theme: o }) => /* @__PURE__ */ t([
    "background-color:",
    ";overflow:hidden;width:100%;",
    ""
  ], r(o).base, i({
    height: [
      "0.4rem",
      "1rem"
    ],
    borderRadius: [
      "0.2rem",
      "0.5rem"
    ]
  })),
  slider: ({ theme: o, error: e }) => /* @__PURE__ */ t([
    "background-color:",
    ";height:100%;"
  ], e ? r(o).slider.error : r(o).slider.normal)
};
export {
  m as default
};
